import { Divider, ScrollVFlex } from '@/components/base';
import DataTable from '@/components/DataTable';
import Empty from '@/components/Empty/Empty';
import Modal from '@/components/Modal/Modal';
import { tableId } from '@/features/Dashboard/Dashboard2ListPage';
import useDashboardActions from '@/features/Dashboard/hooks/useDashboardActions';
import type { Dashboard2ListT, Dashboard2T } from '@/features/Dashboard/types/types';
import type { Dashboard2FolderT } from '@/features/Dashboard/types/types';
import useColor from '@/hooks/domain/useColor';
import useModalState from '@/hooks/pure/useModalState';

import useDashboard2ListTable from '../../hooks/useDashboardListTable';
import DashboardModal from '../DashboardModal';

interface DashboardListTableProps {
  data?: Dashboard2ListT;
  searchValue?: string;
  onEditDashboard: (dashboard: Dashboard2T) => void;
  onEditDashboardFolder?: (dashboardFolder: Dashboard2FolderT) => void;
  onSelectDashboard?: (dashboardKeys: string[]) => void;
  refetch?: () => void;
  checkedList: string[];
  folderAlias: string | null;
  isLoading: boolean;
}

const DashboardListTable: React.FC<DashboardListTableProps> = (props) => {
  const color = useColor();
  const { createDashboard } = useDashboardActions();
  const { tableData, columns } = useDashboard2ListTable({
    searchValue: props.searchValue || null,
    onEditDashboard: props.onEditDashboard,
    onEditDashboardFolder: props.onEditDashboardFolder,
    data: props.data,
    refetch: props.refetch,
    folderAlias: props.folderAlias,
  });

  const createDashboardModalState = useModalState();

  return (
    <ScrollVFlex>
      <Divider backgroundColor={color.gray200} />
      <DataTable
        name={tableId}
        tableHeight="100%"
        datas={tableData}
        columns={columns}
        emptyDataPlaceholder={<Empty title="No dashboard found" />}
        onCheckListChange={(checked) => {
          props.onSelectDashboard?.(checked);
        }}
        checkedList={props.checkedList}
        checkable
        asyncData
        loading={props.isLoading}
      />
      <Modal
        status={createDashboardModalState.status}
        closeModal={createDashboardModalState.close}
      >
        <DashboardModal
          onConfirm={createDashboard}
          title="Create dashboard"
          label="Dashboard name"
          buttonLabel="Create"
        />
      </Modal>
    </ScrollVFlex>
  );
};

export default DashboardListTable;
